module.exports = __webpack_public_path__ + "static/media/web.ccf2a0d4.svg";